module.exports = __webpack_public_path__ + "img/w3_close_white.a2e3f2e2.png";